import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Props {
  payoutDefinitionId: string;
}

const useDeletePayoutDefinitionQuery = ({ payoutDefinitionId }: Props) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(() =>
    api.delete(API_URL.PAYOUT_DEFINITIONS_BY_ID(payoutDefinitionId))
  );
  return {
    isSuccess,
    deletePayoutDefinition: mutateAsync,
    isLoading,
  };
};

export default useDeletePayoutDefinitionQuery;
